(function () {
  function qs(s, r) { return (r || document).querySelector(s); }

  function updateCheckoutState() {
    const drawer = qs('#CartDrawer, .cart-drawer, cart-drawer') || document;
    const checkoutBtn =
      qs('button[name="checkout"], .cart__checkout', drawer || document);

    const tos = qs('#CartTermsDrawer, #Cart-Agree, input[name="attributes[terms_accepted]"]', drawer);
    const privacy = qs('#Privacy-Agree', drawer);

    if (!checkoutBtn) return;

    const ok = (!!tos?.checked || !tos) && (!!privacy?.checked || !privacy);
    checkoutBtn.disabled = !ok;
    checkoutBtn.setAttribute('aria-disabled', String(!ok));
  }

  function bind() {
    const tos = qs('#CartTermsDrawer, #Cart-Agree, input[name="attributes[terms_accepted]"]');
    const privacy = qs('#Privacy-Agree');
    tos && tos.addEventListener('change', updateCheckoutState);
    privacy && privacy.addEventListener('change', updateCheckoutState);
    updateCheckoutState();
  }

  document.addEventListener('DOMContentLoaded', bind);
  new MutationObserver(bind).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart:updated', bind);
})();
